import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import Categories from "@/views/Categories";
import GoodsDetail from "@/views/GoodsDetail";
import User from "@/views/User";
import Cart from "@/views/Cart";
import Order from "@/views/Order";
import Search from "@/views/Search";
import PointsMall from "@/views/PointsMall";
import Detail from "@/views/Detail.vue";
import Confirm from "@/views/Confirm.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/categories",
      name: "Categories",
      component: Categories,
    },
    {
      path: "/goodsdetail",
      name: "GoodsDetail",
      component: GoodsDetail,
    },
    {
      path: "/user",
      name: "User",
      component: User,
    },
    {
      path: "/cart",
      name: "Cart",
      component: Cart,
    },
    {
      path: "/order",
      name: "Order",
      component: Order,
    },
    {
      path: "/search",
      name: "Search",
      component: Search,
    },
    {
      path: "/pointsmall",
      name: "PointsMall",
      component: PointsMall,
    },
    {
      path: "/detail",
      name: "Detail",
      component: Detail,
    },
    {
      path: "/confirm",
      name: "Confirm",
      component: Confirm,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js